import { ReactElement, ReactNode } from 'react';
import styles from './UnOrderedList.module.css';

export interface UnOrderedListItemProps {
    text: string;
    children?: ReactNode;
    textStrong?:boolean;
}

export const UnOrderedListItem = (props: UnOrderedListItemProps) => {
    const {text, children, textStrong = false} = props;

    return (
        <li>
            <span>{!textStrong ? text :<strong>{text}{children}</strong>}</span>
        </li>
    );
};

export interface UnOrderedListProps {
    col?: 2 | 3 | 4 | 5 | 6;
    colPc?: 1 | 2 | 3 | 4 | 5 | 6;
    children: Array<ReactElement<UnOrderedListItemProps>>;
}

export const UnOrderedList = (props: UnOrderedListProps) => {
    const {col, colPc, children} = props;

    return (
        <div className={styles['mod-list']} data-col={col} data-col-pc={colPc}>
            <ul className={styles['list']}>{children}</ul>
        </div>
    );
};
